import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Seo, { useLocalBusinessLd } from "@/components/Seo";

const IMG = "https://images.pexels.com/photos/8135496/pexels-photo-8135496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400";

export default function About() {
  return (
    <Layout>
      <Seo title="À propos | NJ Conciergerie, conciergerie locale à Rouen"
        description="NJ Conciergerie, conciergerie locale spécialisée dans la location courte durée à Rouen et son agglomération. Notre exigence : qualité, proximité, transparence."
        canonical="/a-propos" jsonLd={useLocalBusinessLd()} />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <span className="text-nj-gold text-xs tracking-[0.28em] uppercase font-semibold">À propos</span>
        <h1 className="font-serif font-light text-4xl sm:text-5xl text-nj-text mt-3">NJ Conciergerie, l'exigence locale</h1>
        <div className="grid lg:grid-cols-2 gap-12 mt-10 items-center">
          <div className="overflow-hidden rounded-lg aspect-[4/3]">
            <img src={IMG} alt="NJ Conciergerie" className="w-full h-full object-cover" />
          </div>
          <div className="space-y-4 text-nj-text2 leading-relaxed">
            <p>NJ Conciergerie est une conciergerie spécialisée dans la location courte durée à Rouen et son agglomération. Nous accompagnons les propriétaires dans la valorisation de leur bien et offrons aux voyageurs un séjour confortable et bien organisé.</p>
            <p>Notre équipe locale connaît Rouen sur le bout des doigts : ses quartiers, ses bonnes adresses et ses événements. Nous mettons cette expertise au service de séjours mémorables et d'une gestion sereine pour les propriétaires.</p>
            <p>Notre priorité : la qualité, la proximité et la transparence.</p>
            <div className="pt-4">
              <Link to="/contact" className="bg-nj-primary text-white font-semibold px-6 py-3 rounded-sm hover:bg-nj-primaryHover transition-colors inline-block">Nous contacter</Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
